import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Rocket } from 'lucide-react'
import { computeBetaCountdown, type BetaCountdown } from './betaCountdown'

const TICK_MS = 60_000

const pluralize = (value: number, singular: string, plural: string) => (value === 1 ? singular : plural)

interface BetaCountdownStripViewProps {
  countdown: BetaCountdown
}

export function BetaCountdownStripView({ countdown }: BetaCountdownStripViewProps) {
  const units = [
    { value: countdown.days, label: pluralize(countdown.days, 'día', 'días') },
    { value: countdown.hours, label: pluralize(countdown.hours, 'hora', 'horas') },
    { value: countdown.minutes, label: pluralize(countdown.minutes, 'minuto', 'minutos') },
  ]

  return (
    <section
      aria-label="Cuenta regresiva para el inicio de la fase beta"
      className="w-full bg-slate-900 text-white"
    >
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-center gap-2 px-4 py-2.5 text-center sm:flex-row sm:gap-5 sm:px-6 lg:px-8">
        <p className="flex items-center gap-2 text-sm font-semibold !text-white">
          <Rocket className="h-4 w-4 flex-shrink-0 text-emerald-400" aria-hidden="true" />
          La fase beta empieza el 6 de noviembre
        </p>
        <p className="flex items-center gap-2 text-sm !text-white" role="timer" aria-live="off">
          {units.map((unit) => (
            <span key={unit.label} className="rounded-md bg-emerald-500/20 px-2 py-0.5 ring-1 ring-emerald-400/40">
              <span className="font-bold tabular-nums text-emerald-300">{unit.value}</span> {unit.label}
            </span>
          ))}
        </p>
        <Link
          to="/reserva-tu-lugar"
          className="rounded-md bg-emerald-400 px-3 py-1 text-sm font-semibold !text-slate-900 hover:bg-emerald-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-white"
        >
          Reserva tu lugar
        </Link>
      </div>
    </section>
  )
}

export default function BetaCountdownStrip() {
  const [countdown, setCountdown] = useState(() => computeBetaCountdown(new Date()))

  useEffect(() => {
    const id = setInterval(() => setCountdown(computeBetaCountdown(new Date())), TICK_MS)
    return () => clearInterval(id)
  }, [])

  if (!countdown) return null
  return <BetaCountdownStripView countdown={countdown} />
}
